import { render, staticRenderFns } from "./Observaciones.vue?vue&type=template&id=43b8eba2"
import script from "./Observaciones.vue?vue&type=script&lang=js"
export * from "./Observaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports